import { type HTMLAttributes } from 'react';

import { Text } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './ModalSection.module.scss';

const ModalSection = ({
  title,
  children,
  className,
}: {
  title: string;
  children: React.ReactNode;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}) => {
  return (
    <div className={clsx(styles['modal-section'], className)}>
      <Text className={styles['title']} size="xxlarge" weight="bold">
        {title}
      </Text>
      {children}
    </div>
  );
};

export default ModalSection;
